import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

bootstrapApplication(App, appConfig).catch((err) => {
  if (environment.logging.enabled && !environment.production) {
    console.error(err);
  }
});
